import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AuthPage from './Components/AuthPage';
import AdminDashboard from './Components/AdminDashboard';
import PayrollPage from './Components/PayrollPage'; 
import SettingsPage from './Components/settingsPage';
import Dashboard from './Components/Dashboard';

function App() {
  const [user, setUser] = useState(null); // State to track authenticated user

  // Function to handle login
  const handleLogin = (userData) => {
    setUser(userData); // Set the authenticated user
  };

  // Function to handle logout
  const handleLogout = () => {
    setUser(null); // Clear the authenticated user
  };

  return (
    <Router>
      <Routes>
        {/* Route for the Login Page */}
        <Route
          path="/login"
          element={
            user ? (
              // If the user is already logged in, redirect to the AdminDashboard
              <Navigate to="/dashboard" replace />
            ) : (
              // Otherwise, show the AuthPage
              <AuthPage onLogin={handleLogin} />
            )
          }
        />

        {/* Route for the Admin Dashboard */}
        <Route
          path="/admin"
          element={
            user ? (
              // If the user is logged in, show the AdminDashboard
              <AdminDashboard user={user} onLogout={handleLogout} />
            ) : (
              // Otherwise, redirect to the Login Page
              <Navigate to="/login" replace />
            )
          }
        />
        
        {/* Secure Route for the Payroll Page */}
        <Route
          path="/payrolls"
          element={
            user ? (
              <PayrollPage user={user} onLogout={handleLogout} />
            ) : (
              // Redirect unauthenticated users to the Login Page
              <Navigate to="/login" replace />
            )
          }
        />
  <Route
          path="/dashboard"
          element={
            user ? (
              <Dashboard user={user} onLogout={handleLogout} />
            ) : (
              // Redirect unauthenticated users to the Login Page
              <Navigate to="/login" replace />
            )
          }
        />

<Route
          path="/settings"
          element={
            user ? (
              <SettingsPage user={user} onLogout={handleLogout} />
            ) : (
              // Redirect unauthenticated users to the Login Page
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Default Route (Redirect to Login) */}
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
